import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const LaborProgressBadge: FC = () => {
  const { t } = useTranslation(['component']);

  return (
    <Badge className="bg-purple-500 font-semibold text-white">
      {t('component:badge.laborProgress')}
    </Badge>
  );
};
